// src/oura/components/docs/write/emailStyle.ts
//
// How the client email looks, in one place (#4842). The server's renderer
// (ourteam-backend oura_doc_client_email.render_html) puts its spacing on the
// tags themselves: 14px under every paragraph and list, lists indented 22px,
// links #1a56db. The preview frame and the rich text editor both draw with
// these values, so the editor never looks different from what is sent.

export const EMAIL_FONT = "14px/1.55 Arial,Helvetica,sans-serif";
export const EMAIL_TEXT = "#1f2937";
export const EMAIL_LINK = "#1a56db";
export const EMAIL_GAP = "14px";
export const EMAIL_INDENT = "22px";
export const EMAIL_PADDING = "16px";

/** The preview frame's page: the body the server's HTML sits in. Its links take no click. */
export const PREVIEW_PAGE_CSS = `body{margin:0;padding:${EMAIL_PADDING};font:${EMAIL_FONT};color:${EMAIL_TEXT}}a{color:${EMAIL_LINK};pointer-events:none;cursor:default}`;

/**
 * The editor's content, as the email draws it. draft-js renders one element per
 * block (`[data-block]`): a paragraph is a div, a list item an li inside a
 * ul/ol it wraps them in. The app's base styles reset lists, so their look is
 * set here too.
 */
export const EDITOR_CSS = `
.client-email-editor{padding:${EMAIL_PADDING};font:${EMAIL_FONT};color:${EMAIL_TEXT}}
.client-email-editor [data-block="true"]{margin:0 0 ${EMAIL_GAP} 0}
.client-email-editor li[data-block="true"]{margin:0}
.client-email-editor .public-DraftStyleDefault-block{margin:0}
.client-email-editor ul,.client-email-editor ol{margin:0 0 ${EMAIL_GAP} 0;padding-left:${EMAIL_INDENT}}
.client-email-editor ul{list-style:disc}
.client-email-editor ol{list-style:decimal}
.client-email-editor li{display:list-item;margin-left:0}
.client-email-editor .public-DraftStyleDefault-orderedListItem::before{content:none}
.client-email-editor strong,.client-email-editor b{font-weight:700}
`;
